export default __webpack_public_path__ + "static/media/dozule12.c3cd6948.jpg";